import React, { ReactNode } from 'react';
import styled from 'styled-components';

import SimpleModalOrMobilePage from 'components/basic/modal/SimpleModalOrMobilePage';
import katanaLogo from 'components/layout/header/images/katanaLogoFull.svg';
import katanaImage from 'components/rewards/images/katanaHero4x.png';
import {
  GradientBox,
  purpleGradientTextCss,
} from 'components/s2/Box/PurpleGradientBox';
import Spacer from 'components/s2/Spacer';
import { formatNumber2 } from 'lib/display/formatting';
import { useSelector } from 'reduxState/storeCore';
import { scrollbarStyle } from 'styleShared';

const WrapDesktop = styled.div`
  display: grid;
  grid-template-columns: 238px 1fr;
  min-height: 330px;
  overflow-y: auto;
  ${scrollbarStyle}
`;

const LeftBoxDesktop = styled.div`
  border-radius: 4px 0px 0px 4px;
  display: flex;
  align-items: center;
`;

const RightBoxDesktop = styled.div`
  padding: 32px 64px;
  display: flex;
  justify-items: center;
  flex-direction: column;
  justify-content: center;
`;

const WrapMobile = styled.div`
  height: 100%;
  overflow-y: auto;
  ${scrollbarStyle}
  display: flex;
  flex-direction: column;
`;

const WrapImageMobile = styled.div`
  min-height: 200px;
  flex-grow: 0;
  flex-basis: 50%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const WrapMainMobile = styled.div`
  flex-grow: 1;
  padding: 24px 24px 32px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const MoneyText = styled.div`
  padding: 8px 16px;
  font-size: var(--largestDesktop);
  ${purpleGradientTextCss}
`;

export default function BankrollModalLayout({
  quantity,
  children,
  onClose,
  loading,
}: {
  quantity?: string;
  children: ReactNode;
  onClose?: () => void;
  loading?: boolean;
}) {
  const isMobile = useSelector(state => state.screen.isMobile);

  const main = loading ? null : (
    <>
      <img src={katanaLogo} style={{ width: 166 }} />
      <div style={{ height: 16 }} />
      {quantity && (
        <>
          <GradientBox inline>
            <MoneyText>${formatNumber2(quantity, 2, 0)} Bankroll</MoneyText>
          </GradientBox>
          <Spacer height={12} />
        </>
      )}

      {children}
    </>
  );

  return (
    <SimpleModalOrMobilePage
      size="large"
      onClose={onClose}
      padding="0"
      noMobileHeader
    >
      {isMobile ? (
        <WrapMobile>
          <WrapImageMobile>
            <img src={katanaImage} />
          </WrapImageMobile>
          <WrapMainMobile>{main}</WrapMainMobile>
        </WrapMobile>
      ) : (
        <WrapDesktop>
          <LeftBoxDesktop>
            <img src={katanaImage} width={238} />
          </LeftBoxDesktop>
          <RightBoxDesktop>{main}</RightBoxDesktop>
        </WrapDesktop>
      )}
    </SimpleModalOrMobilePage>
  );
}
